export default __webpack_public_path__ + "static/media/banner1.4d86b9fb.jpg";